"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreImportStoreProductsInnerToJSON = exports.StoreImportStoreProductsInnerFromJSONTyped = exports.StoreImportStoreProductsInnerFromJSON = exports.instanceOfStoreImportStoreProductsInner = exports.StoreImportStoreProductsInnerFulfillmentProviderEnum = exports.StoreImportStoreProductsInnerDetailsProviderEnum = exports.StoreImportStoreProductsInnerPlacementEnum = void 0;
var runtime_1 = require("../runtime");
var StoreImportStoreProductsInnerVariantsInner_1 = require("./StoreImportStoreProductsInnerVariantsInner");
/**
 * @export
 */
exports.StoreImportStoreProductsInnerPlacementEnum = {
    FollowsDesign: 'placement_follows_design',
    Full: 'placement_full'
};
/**
 * @export
 */
exports.StoreImportStoreProductsInnerDetailsProviderEnum = {
    Mms: 'mms',
    Donation: 'donation',
    AdminFee: 'admin_fee'
};
/**
 * @export
 */
exports.StoreImportStoreProductsInnerFulfillmentProviderEnum = {
    Ofs: 'ofs',
    Digital: 'digital'
};
/**
 * Check if a given object implements the StoreImportStoreProductsInner interface.
 */
function instanceOfStoreImportStoreProductsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreImportStoreProductsInner = instanceOfStoreImportStoreProductsInner;
function StoreImportStoreProductsInnerFromJSON(json) {
    return StoreImportStoreProductsInnerFromJSONTyped(json, false);
}
exports.StoreImportStoreProductsInnerFromJSON = StoreImportStoreProductsInnerFromJSON;
function StoreImportStoreProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'storeId': !(0, runtime_1.exists)(json, 'store_id') ? undefined : json['store_id'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'styleId': !(0, runtime_1.exists)(json, 'style_id') ? undefined : json['style_id'],
        'designCompositeId': !(0, runtime_1.exists)(json, 'design_composite_id') ? undefined : json['design_composite_id'],
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : json['price'],
        'position': !(0, runtime_1.exists)(json, 'position') ? undefined : json['position'],
        'imageUrl': !(0, runtime_1.exists)(json, 'image_url') ? undefined : json['image_url'],
        'limited': !(0, runtime_1.exists)(json, 'limited') ? undefined : json['limited'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'features': !(0, runtime_1.exists)(json, 'features') ? undefined : json['features'],
        'placement': !(0, runtime_1.exists)(json, 'placement') ? undefined : json['placement'],
        'minQuantity': !(0, runtime_1.exists)(json, 'min_quantity') ? undefined : json['min_quantity'],
        'wholesalePrice': !(0, runtime_1.exists)(json, 'wholesale_price') ? undefined : json['wholesale_price'],
        'originalPrice': !(0, runtime_1.exists)(json, 'original_price') ? undefined : json['original_price'],
        'detailsProvider': !(0, runtime_1.exists)(json, 'details_provider') ? undefined : json['details_provider'],
        'fulfillmentProvider': !(0, runtime_1.exists)(json, 'fulfillment_provider') ? undefined : json['fulfillment_provider'],
        'variants': !(0, runtime_1.exists)(json, 'variants') ? undefined : (json['variants'].map(StoreImportStoreProductsInnerVariantsInner_1.StoreImportStoreProductsInnerVariantsInnerFromJSON)),
    };
}
exports.StoreImportStoreProductsInnerFromJSONTyped = StoreImportStoreProductsInnerFromJSONTyped;
function StoreImportStoreProductsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'store_id': value.storeId,
        'enabled': value.enabled,
        'name': value.name,
        'style_id': value.styleId,
        'design_composite_id': value.designCompositeId,
        'price': value.price,
        'position': value.position,
        'image_url': value.imageUrl,
        'limited': value.limited,
        'description': value.description,
        'features': value.features,
        'placement': value.placement,
        'min_quantity': value.minQuantity,
        'wholesale_price': value.wholesalePrice,
        'original_price': value.originalPrice,
        'details_provider': value.detailsProvider,
        'fulfillment_provider': value.fulfillmentProvider,
        'variants': value.variants === undefined ? undefined : (value.variants.map(StoreImportStoreProductsInnerVariantsInner_1.StoreImportStoreProductsInnerVariantsInnerToJSON)),
    };
}
exports.StoreImportStoreProductsInnerToJSON = StoreImportStoreProductsInnerToJSON;
